import './App.css';
import Strings from './res/strings';
import Dimens from './res/dimens';
import { Alert, Container, Image, Row, Col, CardDeck } from 'react-bootstrap';
import StretchedLinkedData from './data/StretchedLinkData';
import TableContent from './data/TableContent';
import TopNavBar from './ui/TopNavBar';
import OpenSourceCard from './ui/OpenSourceCard';
import LandingPage from './ui/LandingPage';
import LeftAlignedImageContentRow from './ui/LeftAlignedImageContentRow';
import RightAlignedImageContentRow from './ui/RightAlignedImageContentRow';
import Footer from './ui/Footer';
import Divider from './ui/Divider';
import RightAlignedTableContentRow from './ui/TableContentRow';
import RoleItem from './ui/RoleItem';
import HeadlineSummaryBulletImgInset from './ui/HeadlineSummaryBulletImgInset';
import TripleImgCaptionInset from './ui/TripleImgCaptionInset';
import FourImgCaptionInset from './ui/FourImgCaptionInset';
import imgMvi from './assets/panel-mvi.png';
import imgWebshop from './assets/panel-wsj-2026-01-webshop-v1.png';
import imgPerformance from './assets/panel-performance.png';
import imgRedesign from './assets/panel-redesign.png';
import imgCompose from './assets/panel-compose.png'
import imgPyramid from './assets/img-test-pyramid.png';
import imgPyramid5 from './assets/img-android-5-layer-test-pyramid-markup.png';
import imgThreeEnv from './assets/img-three-env.png';
import imgMultiApp from './assets/img-multimodule-app.png';
import imgTrunkScale from './assets/img-trunk-scale.png';
import imgApi from './assets/img-api.png';
import imgFigma from './assets/img-figma.svg.png';
import imgGantt from './assets/img-gantt-square.png';
import imgCollab from './assets/img-discovery-collaboration.png';
import imgAnalytics from './assets/img-google-analytics.svg.png';
import imgPlatform from './assets/panel-wsj-2026-01.png';
import imgMountains from './assets/img-mountains.jpg';

function App() {
  return (
    <div>
      <TopNavBar resumeUrl={Strings.URL_RESUME} />
      <Container>
        <Row>
          <Col md={{ span: 8, offset: 0 }}>
            <LandingPage title={Strings.NAME} summary={Strings.LANDING_SUBTITLE} />
          </Col>
        </Row>
        <h2 class="display-2" id="about">{Strings.ABOUT_TITLE}</h2>
        <Row className="mt-5 mb-5">
          <Col className="justify-content-around">
            <p class="lead">{Strings.ABOUT_DESCRIPTION}</p>
            <h5>{Strings.ABOUT_INDUSTRY_ITEM}</h5>
            <ul>
                <li>{Strings.ABOUT_INDUSTRY_SUBITEM_SCALE}</li>
                <li>{Strings.ABOUT_INDUSTRY_SUBITEM_TEST}</li>
                <li>{Strings.ABOUT_INDUSTRY_SUBITEM_ACCESS}</li>
                <li>{Strings.ABOUT_INDUSTRY_SUBITEM_PERFORMANCE}</li>
            </ul>
            <h5>{Strings.ABOUT_INDUSTRY_ITEM_KOTLIN_COMPOSE}</h5>
            <h5>{Strings.ABOUT_INDUSTRY_ITEM_DIRECTION}</h5>
          </Col>
        </Row>
        <h2 class="display-2" id="wsj">{Strings.WSJ}</h2>
        <Row>
          <Col className="justify-content-around">
            <RightAlignedTableContentRow
              title={Strings.KEY_RESULTS_TITLE}
              subtitle={Strings.KEY_RESULTS_SUBTITLE}
              summary={[
                new StretchedLinkedData(Strings.URL_PLAY_WSJ, Strings.KEY_RESULT_PLAY_ANCHOR, Strings.KEY_RESULT_PLAY_TEXT),
                Strings.KEY_RESULT_APP_PLATFORM,
                Strings.KEY_RESULT_TEAM
              ]}
              tableContent={new TableContent()} />
            <h1>{Strings.ROLES_TITLE}</h1>
            <h2 className="text-muted">{Strings.ROLES_SUBTITLE}</h2>
            <br></br>
            <RoleItem
                title={Strings.ROLES_STAFF}
                date={Strings.ROLES_STAFF_DATE}
                summaryOne={Strings.ROLES_STAFF_TECH_LEAD}
                summaryTwo={Strings.ROLES_STAFF_APP_PLATFORM}
                summaryThree={Strings.ROLES_STAFF_WEBSHOP}
                summaryFour={Strings.ROLES_STAFF_CICD} />
            <RoleItem
                title={Strings.ROLES_LEAD}
                date={Strings.ROLES_LEAD_DATE}
                summaryOne={Strings.ROLES_LEAD_MULTIPLATFORM} />
            <RoleItem
                title={Strings.ROLES_SENIOR}
                date={Strings.ROLES_SENIOR_DATE}
                summaryOne={Strings.ROLES_SENIOR_EXPERIMENTAL}
                summaryTwo={Strings.ROLES_SENIOR_LOGIN_SUB} />
            <RoleItem
                title={Strings.ROLES_SOFTWARE}
                date={Strings.ROLES_SOFTWARE_DATE}
                summaryOne={Strings.ROLES_SOFTWARE_REDESIGN} />
            <Divider
              height={Dimens.DIVIDER_HEIGHT} />
            <LeftAlignedImageContentRow
              title={Strings.REDESIGN_TITLE}
              subtitle={Strings.REDESIGN_SUBTITLE}
              summary={Strings.REDESIGN_SUMMARY}
              img={imgRedesign} />
            <Divider
              height={Dimens.DIVIDER_HEIGHT} />
            <RightAlignedImageContentRow
              title={Strings.WEBSHOP_TITLE}
              subtitle={Strings.WEBSHOP_SUBTITLE}
              summary={Strings.WEBSHOP_SUMMARY}
              img={imgWebshop} />
            <Divider
              height={Dimens.DIVIDER_HEIGHT} />
            <LeftAlignedImageContentRow
              title={Strings.ARCH_TITLE}
              subtitle={Strings.ARCH_SUBTITLE}
              summary={Strings.ARCH_SUMMARY}
              img={imgMvi} />
            <Divider
              height={Dimens.DIVIDER_HEIGHT} />
            <RightAlignedImageContentRow
              title={Strings.UI_TITLE}
              subtitle={Strings.UI_SUBTITLE}
              summary={Strings.UI_SUMMARY}
              img={imgCompose} />
            <Divider
              height={Dimens.DIVIDER_HEIGHT} />
            <LeftAlignedImageContentRow
              title={Strings.GRAPH_TITLE}
              subtitle={Strings.GRAPH_SUBTITLE}
              summary={Strings.GRAPH_SUMMARY}
              img={imgPerformance} />
            <Divider
              height={Dimens.DIVIDER_HEIGHT} />
            <RightAlignedImageContentRow
              title={Strings.PLATFORM_TITLE}
              subtitle={Strings.PLATFORM_SUBTITLE}
              summary={Strings.PLATFORM_SUMMARY}
              img={imgPlatform} />
            <Divider
              height={Dimens.DIVIDER_HEIGHT} />
          </Col>
        </Row>
        <h2 class="display-2" id="opensource">{Strings.OPEN_SOURCE}</h2>
        <CardDeck>
          <OpenSourceCard
            header={Strings.ANDROID_KOTLIN}
            title={Strings.MET_TITLE}
            summary={Strings.MET_SUMMARY}
            gitHubUrl={Strings.URL_GITHUB_MET} />
          <OpenSourceCard
            header={Strings.ANDROID_KOTLIN}
            title={Strings.COMPOSE_TITLE}
            summary={Strings.COMPOSE_SUMMARY}
            gitHubUrl={Strings.URL_GITHUB_COMPOSE} />
          <OpenSourceCard
            header={Strings.WEB}
            title={Strings.RESUME_TITLE}
            summary={Strings.RESUME_SUMMARY}
            gitHubUrl={Strings.URL_GITHUB_RESUME} />
        </CardDeck>
        <CardDeck>
          <OpenSourceCard
            header={Strings.ANDROID_KOTLIN}
            title={Strings.LFWK_NAME}
            summary={Strings.LFWK_SUMMARY}
            gitHubUrl={Strings.URL_GITHUB_LFWK}
            playStoreUrl={Strings.URL_PLAY_LFWK} />
          <OpenSourceCard
            header={Strings.ANDROID_JAVA}
            title={Strings.ADAPTER_TITLE}
            summary={Strings.ADAPTER_SUMMARY}
            gitHubUrl={Strings.URL_GITHUB_ADAPTER} />
          <OpenSourceCard
            header={Strings.ANDROID_JAVA}
            title={Strings.TWITTER_TITLE}
            summary={Strings.TWITTER_SUMMARY}
            gitHubUrl={Strings.URL_GITHUB_TWITTER} />
        </CardDeck>
        <h2 class="display-2" id="playbook">{Strings.PLAYBOOK_TITLE}</h2>
        <h4 class="display-4 text-muted" >{Strings.PLAYBOOK_SUBTITLE}</h4>
        <p class="lead">{Strings.PLAYBOOK_LEAD}</p>
        <Row className="mt-5 mb-5">
            <Col className="justify-content-around">
                <h1 >{Strings.PLAYBOOK_DISCOVERY}</h1>
                <h2 class="text-muted">{Strings.PLAYBOOK_DISCOVERY_SUBTITLE}</h2>
                <br></br>
                <FourImgCaptionInset
                    imgOneSrc={imgFigma}
                    captionOne={Strings.PLAYBOOK_CAPTION_UI}
                    imgTwoSrc={imgApi}
                    captionTwo={Strings.PLAYBOOK_CAPTION_API}
                    imgThreeSrc={imgAnalytics}
                    captionThree={Strings.PLAYBOOK_CAPTION_ANALYTICS}
                    imgFourSrc={imgGantt}
                    captionFour={Strings.PLAYBOOK_CAPTION_GANTT} />
                <br></br>
                <h3>{Strings.PLAYBOOK_DISCOVERY_GOAL}</h3>
                <p>{Strings.PLAYBOOK_DISCOVERY_GOAL_LEAD}</p>
                <p>{Strings.PLAYBOOK_DISCOVERY_SUMMARY}</p>
                <h3>{Strings.PLAYBOOK_DISCOVERY_PROCESS}</h3>
                <ol>
                    <li>{Strings.PLAYBOOK_DISCOVERY_KICKOFF}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_BREAKOUT}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_REGROUP}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_REPEAT}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_INTAKE}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_CREATE}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_ITERATE}</li>
                </ol>
                <Image src={imgCollab} fluid />
                <h3>{Strings.PLAYBOOK_DISCOVERY_OUTCOME}</h3>
                <h4 class="text-muted">{Strings.PLAYBOOK_DISCOVERY_PRODUCT}</h4>
                <ul>
                    <li>{Strings.PLAYBOOK_DISCOVERY_PRODUCT_GOAL}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_PRODUCT_EXPERIMENT}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_PRODUCT_ANALYTICS}</li>
                </ul>
                <Alert variant="info">{Strings.PLAYBOOK_DISCOVERY_PRODUCT_WHY}</Alert>
                <h4 class="text-muted">{Strings.PLAYBOOK_DISCOVERY_DESIGN}</h4>
                <ul>
                    <li>{Strings.PLAYBOOK_DISCOVERY_DESIGN_UI}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_DESIGN_UX}</li>
                </ul>
                <Alert variant="info">{Strings.PLAYBOOK_DISCOVERY_DESIGN_WHY}</Alert>
                <h4 class="text-muted">{Strings.PLAYBOOK_DISCOVERY_ENGINEERING}</h4>
                <ul>
                    <li>{Strings.PLAYBOOK_DISCOVERY_ENGINEERING_API}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_ENGINEERING_DIAGRAM}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_ENGINEERING_SUGGESTED}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_ENGINEERING_TWO_PAGER}</li>
                </ul>
                 <Alert variant="info">{Strings.PLAYBOOK_DISCOVERY_ENGINEERING_WHY}</Alert>
                <h4 class="text-muted">{Strings.PLAYBOOK_DISCOVERY_MANAGER}</h4>
                <ul>
                    <li>{Strings.PLAYBOOK_DISCOVERY_GANTT}</li>
                    <li>{Strings.PLAYBOOK_DISCOVERY_TICKET}</li>
                </ul>
                <Alert variant="info">{Strings.PLAYBOOK_DISCOVERY_MANAGER_WHY}</Alert>
                <br></br>
                <h1>{Strings.PLAYBOOK_MULTIMODULE}</h1>
                <h2 class="text-muted">{Strings.PLAYBOOK_MULTIMODULE_SUBTITLE}</h2>
                <br></br>
                <HeadlineSummaryBulletImgInset
                    summary={Strings.PLAYBOOK_MULTIMODULE_SUMMARY}
                    items={[
                        Strings.PLAYBOOK_MULTIMODULE_SEPARATE,
                        Strings.PLAYBOOK_MULTIMODULE_REUSE,
                        Strings.PLAYBOOK_MULTIMODULE_TEST,
                        Strings.PLAYBOOK_MULTIMODULE_SWAP,
                        Strings.PLAYBOOK_MULTIMODULE_BUILD_TIMES,
                        Strings.PLAYBOOK_MULTIMODULE_DISTRIBUTION
                    ]}
                    img={imgMultiApp} />
                <h1>{Strings.PLAYBOOK_CI}</h1>
                <h2 class="text-muted">{Strings.PLAYBOOK_CI_SUBTITLE}</h2>
                <br></br>
                <HeadlineSummaryBulletImgInset
                    headline={Strings.PLAYBOOK_THREE_ENV_TEST}
                    summary={Strings.PLAYBOOK_THREE_ENV_SUMMARY}
                    items={[
                        Strings.PLAYBOOK_THREE_ENV_DEV_INT,
                        Strings.PLAYBOOK_THREE_ENV_PROD,
                        Strings.PLAYBOOK_THREE_ENV_ROLE
                    ]}
                    img={imgThreeEnv} />
                <HeadlineSummaryBulletImgInset
                    headline={Strings.PLAYBOOK_APP_BRANCHING_STRATEGY}
                    summary={Strings.PLAYBOOK_APP_BRANCHING_STRATEGY_SUMMARY}
                    items={[
                        Strings.PLAYBOOK_APP_BRANCHING_STRATEGY_BEFORE,
                        Strings.PLAYBOOK_APP_BRANCHING_STRATEGY_ENSURES,
                        Strings.PLAYBOOK_APP_BRANCHING_STRATEGY_HOTFIX
                    ]}
                    img={imgTrunkScale}
                    source={Strings.PLAYBOOK_APP_TRUNK_SOURCE}
                    sourceLink={Strings.URL_TRUNK} />
                <h1>{Strings.PLAYBOOK_AUTOMATED_TESTING}</h1>
                <h2 class="text-muted">{Strings.PLAYBOOK_AUTOMATED_TESTING_SUBTITLE}</h2>
                <br></br>
                <HeadlineSummaryBulletImgInset
                    headline={Strings.PLAYBOOK_TEST_PYRAMID_HEADLINE}
                    summary={Strings.PLAYBOOK_TEST_PYRAMID_SUMMARY}
                    items={[
                        Strings.PLAYBOOK_TEST_PYRAMID_UI,
                        Strings.PLAYBOOK_TEST_PYRAMID_INTEGRATION,
                        Strings.PLAYBOOK_TEST_PYRAMID_UNIT
                    ]}
                    img={imgPyramid}
                    source={Strings.PLAYBOOK_TEST_PYRAMID_SOURCE}
                    sourceLink={Strings.URL_ANYMIND} />
                <HeadlineSummaryBulletImgInset
                    headline={Strings.PLAYBOOK_TEST_PYRAMID_5_HEADLINE}
                    summary={Strings.PLAYBOOK_TEST_PYRAMID_5_SUMMARY}
                    items={[
                        Strings.PLAYBOOK_TEST_PYRAMID_5_RELEASE,
                        Strings.PLAYBOOK_TEST_PYRAMID_5_APPLICATION,
                        Strings.PLAYBOOK_TEST_PYRAMID_5_FEATURE,
                        Strings.PLAYBOOK_TEST_PYRAMID_5_COMPONENT,
                        Strings.PLAYBOOK_TEST_PYRAMID_5_UNIT
                    ]}
                    img={imgPyramid5}
                    source={Strings.PLAYBOOK_TEST_PYRAMID_5_SOURCE}
                    sourceLink={Strings.URL_ANDROID_TESTING_STRATEGY} />    
            </Col>
        </Row>
        <h2 class="display-2" id="languages">{Strings.LANGUAGES_TITLE}</h2>
        <Row className="mt-5 mb-5">
          <Col className="justify-content-around">
            <h1 class="text-muted">{Strings.LANGUAGES_COMPUTER}</h1>
            <h1>{Strings.LANGUAGES_KOTLIN}</h1>
            <h2>{Strings.LANGUAGES_JAVA}</h2>
            <h3>{Strings.LANGUAGES_DART}</h3>
            <h4>{Strings.LANGUAGES_JAVASCRIPT}</h4>
            <h5>{Strings.TOOLS_TITLE}</h5>
            <p>{Strings.TOOLS}</p>
            <br></br>
            <h1 class="text-muted">{Strings.LANGUAGES_HUMAN}</h1>
            <h1>{Strings.LANGUAGES_ENGLISH}</h1>
            <h2>{Strings.LANGUAGES_FRENCH}</h2>
            <h3>{Strings.LANGUAGES_JAPANESE}</h3>
          </Col>
        </Row>
        <h2 class="display-2" id="languages">{Strings.THANKS}</h2>
        <Row>
            <Col className="justify-content-around">
            <LeftAlignedImageContentRow
              title={Strings.SEE_YOU}
              subtitle={Strings.EMOJIS}
              summary={Strings.WHISTLER}
              img={imgMountains} />
            </Col>
        </Row>
      </Container>
      <Footer
        title={Strings.CONTACT}
        gitHubUrl={Strings.URL_GITHUB}
        linkedInUrl={Strings.URL_LINKEDIN} />
    </div>
  );
}

export default App;
